<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                
          <h2 class="mb-0">
            {{ $t('message.compteRenduOperatoire') }}
          </h2>
        </div>
      </div>

      <div class="">
            <b-row>
              <b-col col sm="8">
                <div class="list-group">
                  <b-row>
                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title"> {{ $t('message.etablissementIntervention') }} </h4>
                        <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                      </div>
                    </b-col>
                    
                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.typeIntervention') }} </h4>

                        <p class="consultation-item__body"> {{mCompteRendu.type_intervention }} </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.dateIntervention') }} </h4>

                        <p class="consultation-item__body"> {{ formattedDate(mCompteRendu.date_intervention) }} </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.chirugiens') }} </h4>

                        <p class="consultation-item__body"> {{ mCompteRendu.chirugiens}} </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.aide') }} </h4>

                        <p class="consultation-item__body"> {{ mCompteRendu.aides}} </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.circulant') }} </h4>

                        <p class="consultation-item__body"> {{ mCompteRendu.circulants}} </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.anesthesistes') }} </h4>

                        <p class="consultation-item__body"> {{ mCompteRendu.anesthesistes}} </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.typeAnesthesie') }} </h4>

                        <p class="consultation-item__body"> {{ mCompteRendu.type_anesthesie}} </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.descriptionIntervention') }} </h4>

                        <p class="consultation-item__body" v-html="mCompteRendu.description"> </p>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.traitementPostOperatoire') }} </h4>

                        <p class="consultation-item__body" v-html="mCompteRendu.traitement_post_operatoire"> </p>
                      </div>
                    </b-col>



                  </b-row>
                </div>

              </b-col>
              <b-col col sm="4">
                <b-row class="justify-content-sm-center">

                  <div class="card-footer text-right">
                    <div v-if="!hasGestionnaireRole" @click="ImprimerConsultation" class="custom-print-wrapper">
                      <button class="custom-print-button">
                        <span class="custom-print-icon"></span>
                      </button>
                      <p class="custom-print-label">
                        {{ $t('message.print') }}  {{ $t('message.compteRenduOperatoire') }}
                      </p>
                    </div>
                    <br>
                    <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                      {{ $t('message.edit') }}
                    </b-button>
                    <br>
                    <br>

                    <b-button variant="success" @click="archieveConsultation" v-if="!isTransmitted(mCompteRendu.passed_at) && isArchived(mCompteRendu.archieved_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                      {{ $t('message.archieve') }}
                    </b-button>
                    <br>
                    <b-button variant="info" @click="transmitConsultation" v-if="isTransmitted(mCompteRendu.passed_at) && mCompteRendu.isAuthor && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                      {{ $t('message.transmit') }}
                    </b-button>
                    <br>
                    <br>

                    <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                      {{ $t('message.reavivate') }} {{$tc('message.consultations',1) }}
                    </b-button>
                    <br>
                    <br>

                    <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                      {{ $t('message.delete') }}
                    </b-button>
                    <br>
                    <p v-if="errorshasField('nonTransmis')" style="color:red"  class="justify-content-sm-center">
                      {{getErrorsField('nonTransmis')}}
                    </p>
                  </div>
                </b-row>
              </b-col>
            </b-row>

        <div class="card">
          <b-modal
              id="delete-modal"
              size="sm"
              header-bg-variant="danger"
              header-text-variant="light"
              :title="$t('message.delete') + ' ' + $t('message.compteRenduOperatoire')"
              hide-footer
          >
            <div class="d-block text-center">
              <h3>{{ $t('message.delete') }} {{ formattedDate(mCompteRendu.date_intervention) }}</h3>
            </div>

            <div class="d-block float-md-right d-sm-flex justify-content-sm-center">
              <b-button variant="danger" @click="deleteConsultation" >
                {{ $t('message.delete') }}
              </b-button>

              <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                {{ $t('message.cancel') }}
              </b-button>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import AppConfig from "@/constants/AppConfig";
import moment from "moment";
import $ from "jquery";

export default {
name: "Show",
  computed: {
    ...mapGetters(["compteRendu",
      'errors',
      'hasAdminRole',
      'hasMedecinControleRole',
      'hasAssistante',
      "hasSouscripteurRole",
      "hasPatientRole",
      'hasPraticienRole',
      'hasGestionnaireRole']),

    image: function() {
      if (!_.isUndefined(this.mCompteRendu.file) && !_.isNull(this.mCompteRendu.file)){
        if (this.mCompteRendu.file.length >0 && this.mCompteRendu.file != 'null'){
          return AppConfig.imgUrl + '/public/storage/' + this.mCompteRendu.file;
        }
        return "";
      }
      return "";
    },

    isDefine:function(){
      return (this.compteRendu.file != 'null' && !_.isNull(this.compteRendu.file)) || this.files.length>0;
    },

    isImage:function(){
      if( this.compteRendu.file != 'null' && !_.isEmpty(this.compteRendu.file)){
        return (this.compteRendu.file).includes('.jpeg') || (this.compteRendu.file).includes('.png')|| (this.compteRendu.file).includes('.jpg');
      }
      return  false;
    },

    mCompteRendu: function() {
      return this.compteRendu;
    },

    contributeurs:function(){
      let cArray = [];
      if (!_.isUndefined(this.compteRendu)){
        if (!_.isUndefined(this.compteRendu.operationables)){
          _.forEach(this.compteRendu.operationables,function (operation) {
            if (!_.isUndefined(operation.contributable)){
              let contributable = operation.contributable;
              let prenom = contributable.prenom != 'null' ? contributable.prenom : '';
              prenom =  prenom.toLowerCase();
              let nomComplet = (contributable.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
              cArray.push({nom:nomComplet})  ;
            }
          });
        }
      }
      return cArray;
    },

    isAuthor:function(){
      return this.mCompteRendu.isAuthor;
    },

    canUpdate:function(){
      return this.mCompteRendu.canUpdate;
    },

    canReactive:function(){
      return !_.isNull(this.mCompteRendu.passed_at) && (this.hasAdminRole || this.hasMedecinControleRole || this.hasAssistante);
    },

    canDelete:function(){
      if (this.hasAdminRole)
        return true;
      return this.mCompteRendu.isAuthor && _.isNull(this.mCompteRendu.archieved_at) && _.isNull(this.mCompteRendu.passed_at);
    },

    etablissement:function(){
      if (!_.isUndefined(this.compteRendu)){
        if (!_.isUndefined(this.compteRendu.etablissement)){
          if (!_.isNull(this.compteRendu.etablissement)){
            return this.compteRendu.etablissement.name;
          }
          return "";
        }
      }
      return  "";
    },

    praticien:function(){
      let author = this.mCompteRendu.author;
      if (!_.isNull(author) && !_.isUndefined(author)){
        if (author.hasOwnProperty('user')){
          let user = author.user
          if (!_.isUndefined(user) && !_.isNull(user)) {
            let prenom = (user.prenom == null) ? '' : user.prenom;
            return (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
          }
        }else{
          if (!_.isUndefined(author) && !_.isNull(author)) {
            let prenom = (author.prenom == null) ? '' : author.prenom;
            return (author.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
          }
        }
      }
      return  "";
    },

    nom: function() {
      if (typeof(this.compteRendu.dossier) =='object'){
        let user = this.compteRendu.dossier.patient.user;

        let nom = user.nom;
        let prenom = user.prenom != null ? user.prenom : '';

        return  prenom +" "+ nom.toUpperCase();
      }else{
        return "";
      }
    },

  },

  data() {
    return {
      compte_rendu: this.$route.params.compteRendu,

      paginationOptions:{
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled:{enabled: true},

      sort:{
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },

    }
  },

  methods: {
    openFile(file){
      window.open(AppConfig.imgUrl + '/public/storage/' + file.chemin);
    },

    ImprimerConsultation(){
      let args = {
        compte_rendu_operatoire: this.compte_rendu
      };

      this.$store.dispatch("printCompteRendu", { args });
    },


    allerA(item){
      return this.$route.path + item;
    },


    notEmpty(item){
      if (item)
        return item.length > 0;

      return false;
    },

    getCompteRendu() {
      let args = {
        compte_rendu_operatoire: this.compte_rendu
      };

      this.$store.dispatch("getCompteRendu", { args });
    },

    formattedDate(date) {
      return moment(date).format('DD-MM-YYYY HH:mm');
    },

    updateConsultation() {
      this.$router.push({ name: 'edit-compte-rendu', params: { compteRendu: this.compte_rendu } });
    },

    deleteConsultation() {
      let self = this;
      let args = {
        compte_rendu_operatoire: this.compte_rendu
      };

      let successMessage = this.$i18n.t('message.compteRendu.operatoireDeleted');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('deleteCompteRendu', { args, index: self.compte_rendu_operatoire, successMessage, errorMessages });
    },

    archieveConsultation(){
      let self = this;
      let args = {
        compte_rendu_operatoire: this.compte_rendu
      };

      let successMessage = this.$i18n.t('message.medecineConsultationArchieved');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('archieveMedecinecompteRendu', { args, index: self.consultation_id, successMessage, errorMessages });

    },

    transmitConsultation(){
      let self = this;
      let args = {
        compte_rendu_operatoire: this.compte_rendu
      };

      let successMessage = this.$i18n.t('message.compteRendu.operatoireTransmit');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('transmitMedecinecompteRendu', { args, index: self.consultation_id, successMessage, errorMessages });

    },

    reactiveConsultation(){
      let self = this;
      let args = {
        compte_rendu_operatoire: this.compte_rendu
      };

      let successMessage = this.$i18n.t('message.medecineConsultationReactived');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('reactiveMedecinecompteRendu', { args, index: self.consultation_id, successMessage, errorMessages });

    },

    isArchived:function(date){
      let momentDate = moment(date);
      return !momentDate.isValid() ;
    },

    isTransmitted:function(date){
      var momentDate = moment(date);
      return !momentDate.isValid() ;
    },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },
    errorshasField(field){
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },
    clearErrorField(field){
      this.$store.dispatch('clearErrorField', { field });
      this.getErrorsField(field);
    },
    pathHas(element){
      let result = (this.$route.fullPath).includes(element);
      if(result){
        if ($('#'+element).length){
          document.getElementById(element).scrollIntoView(top);
        }
      }

      return result;
    }
  },

  mounted() {
    this.getCompteRendu();
  }
}
</script>

<style scoped>

</style>